module.exports = __webpack_public_path__ + "img/20200509145358TIM截图20200509143527.25bcef0b.png";